// import React from "react";

// const LocationSelector = () => {
//   return (
//     <div className="w-full h-[380px] p-[15px] flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
//       {/* Search Bar */}
//       <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
//         <input
//           type="text"
//           placeholder="Search city"
//           className="flex-grow p-2 border rounded-md outline-none"
//         />
//         <button className="ml-2 text-gray-500">Clear</button>
//       </div>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-3 gap-2.5 w-full">
//         {Array.from({ length: 12 }).map((_, index) => (
//           <div
//             key={index}
//             className="w-full h-24 bg-gray-300 rounded-md shadow-md"
//           ></div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default LocationSelector;


// import React from "react";

// const ChooseLocation = () => {
//   // Array of Karkala district names
//   const locations = [
//     "Belagavi", "Hubli", "Udupi", "Dharwad", "Moodabidri", "Byndoor",
//     "Kundapura", "Kasaragod", "Mangalore", "Haveri", "Shivmogga",
//     "Vijaypur",
//   ];

//   return (
//     <div className="w-full h-[380px] p-[15px] flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
//       {/* Search Bar */}
//       <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
//         <input
//           type="text"
//           placeholder="Search city"
//           className="flex-grow p-2 border rounded-md outline-none"
//         />
//         <button className="ml-2 text-gray-500">Clear</button>
//       </div>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-3 gap-2.5 w-full">
//         {locations.map((location, index) => (
//           <div
//             key={index}
//             className="w-full h-32 bg-gray-300 rounded-md shadow-md flex items-center justify-center text-gray-700 font-semibold"
//           >
//             {location}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ChooseLocation;


// import React, { useState } from "react";

// const ChooseLocation = () => {
//   // Array of Karkala district names
//   const locations = [
//     "Belagavi", "Hubli", "Udupi", "Dharwad", "Moodabidri", "Byndoor",
//     "Kundapura", "Kasaragod", "Mangalore", "Haveri", "Shivmogga",
//     "Vijaypur",
//   ];

//   // State for the search input
//   const [searchTerm, setSearchTerm] = useState("");

//   // Filter locations based on search input
//   const filteredLocations = locations.filter(location =>
//     location.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Function to clear the search input
//   const clearSearch = () => {
//     setSearchTerm("");
//   };

//   return (
//     <div className="w-full h-auto p-4 flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
//       {/* Search Bar */}
//       <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)} // Update state on input change
//           placeholder="Search city"
//           className="flex-grow p-2 border rounded-md outline-none"
//         />
//         <button onClick={clearSearch} className="ml-2 text-gray-500">
//           Clear
//         </button>
//       </div>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5 w-full">
//         {filteredLocations.map((location, index) => (
//           <div
//             key={index}
//             className="w-full h-32 bg-[#FF9630] rounded-md shadow-md flex items-center justify-center text-gray-700 font-semibold"
//           >
//             {location}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ChooseLocation;


// import React, { useState } from "react";

// const ChooseLocation = () => {
//   // Array of Karkala district names
//   const locations = [
//     "Belagavi", "Hubli", "Udupi", "Dharwad", "Moodabidri", "Byndoor",
//     "Kundapura", "Kasaragod", "Mangalore", "Haveri", "Shivmogga",
//     "Vijaypur",
//   ];

//   // State for the search input
//   const [searchTerm, setSearchTerm] = useState("");

//   // Filter locations based on search input
//   const filteredLocations = locations.filter(location =>
//     location.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Function to clear the search input
//   const clearSearch = () => {
//     setSearchTerm("");
//   };

//   // Function to handle location click
//   const handleLocationClick = (location) => {
//     setSearchTerm(location); // Set the selected location to the input field
//   };

//   return (
//     <div className="w-full h-auto p-4 flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
//       {/* Search Bar */}
//       <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)} // Update state on input change
//           placeholder="Search city"
//           className="flex-grow p-2 border rounded-md outline-none"
//         />
//         <button onClick={clearSearch} className="ml-2 text-gray-500">
//           Clear
//         </button>
//       </div>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5 w-full">
//         {filteredLocations.map((location, index) => (
//           <div
//             key={index}
//             onClick={() => handleLocationClick(location)} // Handle click event
//             className="w-full h-32 bg-[#FF9630] rounded-md shadow-md flex items-center justify-center text-gray-700 font-semibold cursor-pointer"
//           >
//             {location}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ChooseLocation;

// import React, { useState } from "react";
// import belagavi from "../assets/dhwd.jpg";
// import hubli from "../assets/bgm.jpg";
// import udupi from "../assets/dhwd.jpg";
// import dharwad from "../assets/bgm.jpg";
// import moodabidri from "../assets/dhwd.jpg";
// import byndoor from "../assets/bgm.jpg";
// import kundapura from "../assets/dhwd.jpg";
// import kasaragod from "../assets/bgm.jpg";
// import mangalore from "../assets/dhwd.jpg";
// import haveri from "../assets/bgm.jpg";
// import shivmogga from "../assets/dhwd.jpg";
// import vijaypur from "../assets/bgm.jpg";

// const ChooseLocation = () => {
//   // Array of Karkala district names with images
//   const locations = [
//     { name: "Belagavi", image: belagavi },
//     { name: "Hubli", image: hubli },
//     { name: "Udupi", image: udupi },
//     { name: "Dharwad", image: dharwad },
//     { name: "Moodabidri", image: moodabidri },
//     { name: "Byndoor", image: byndoor },
//     { name: "Kundapura", image: kundapura },
//     { name: "Kasaragod", image: kasaragod },
//     { name: "Mangalore", image: mangalore },
//     { name: "Haveri", image: haveri },
//     { name: "Shivmogga", image: shivmogga },
//     { name: "Vijaypur", image: vijaypur },
//   ];

//   // State for the search input
//   const [searchTerm, setSearchTerm] = useState("");

//   // Filter locations based on search input
//   const filteredLocations = locations.filter((location) =>
//     location.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Function to clear the search input
//   const clearSearch = () => {
//     setSearchTerm("");
//   };

//   // Function to handle location click
//   const handleLocationClick = (locationName) => {
//     setSearchTerm(locationName); // Set the selected location to the input field
//   };

//   return (
//     <div className="w-full h-auto p-4 flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
//       {/* Search Bar */}
//       <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)} // Update state on input change
//           placeholder="Search city"
//           className="flex-grow p-2 border rounded-md outline-none"
//         />
//         <button onClick={clearSearch} className="ml-2 text-gray-500">
//           Clear
//         </button>
//       </div>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5 w-full">
//         {filteredLocations.map((location, index) => (
//           <div
//             key={index}
//             onClick={() => handleLocationClick(location.name)} // Handle click event
//             className="w-full h-32 bg-[#FF9630] rounded-md shadow-md flex items-center justify-center text-gray-700 font-semibold cursor-pointer relative overflow-hidden"
//           >
//             <img
//               src={location.image}
//               alt={location.name}
//               className="absolute w-full h-full object-cover opacity-80"
//             />
//             <span className="relative z-10 text-white">{location.name}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ChooseLocation;

// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { setLocation } from "../../Redux/Slice/locationSlice"; // Import the action

// import belagavi from "../assets/dhwd.jpg";
// import hubli from "../assets/bgm.jpg";
// import udupi from "../assets/dhwd.jpg";
// import dharwad from "../assets/bgm.jpg";
// import moodabidri from "../assets/dhwd.jpg";
// import byndoor from "../assets/bgm.jpg";
// import kundapura from "../assets/dhwd.jpg";
// import kasaragod from "../assets/bgm.jpg";
// import mangalore from "../assets/dhwd.jpg";
// import haveri from "../assets/bgm.jpg";
// import shivmogga from "../assets/dhwd.jpg";
// import vijaypur from "../assets/bgm.jpg";

// const ChooseLocation = () => {
//   const dispatch = useDispatch(); // Redux dispatch hook

//   const locations = [
//     { name: "Belagavi", image: belagavi },
//     { name: "Hubli", image: hubli },
//     { name: "Udupi", image: udupi },
//     { name: "Dharwad", image: dharwad },
//     { name: "Moodabidri", image: moodabidri },
//     { name: "Byndoor", image: byndoor },
//     { name: "Kundapura", image: kundapura },
//     { name: "Kasaragod", image: kasaragod },
//     { name: "Mangalore", image: mangalore },
//     { name: "Haveri", image: haveri },
//     { name: "Shivmogga", image: shivmogga },
//     { name: "Vijaypur", image: vijaypur },
//   ];

//   const [searchTerm, setSearchTerm] = useState("");

//   const filteredLocations = locations.filter((location) =>
//     location.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const clearSearch = () => {
//     setSearchTerm("");
//   };

//   const handleLocationClick = (locationName) => {
//     setSearchTerm(locationName); // Set the selected location to the input field
//     dispatch(setLocation(locationName)); // Dispatch to Redux store
//   };

//   return (
//     <div className="w-full h-auto p-4 flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
//       {/* Search Bar */}
//       <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search city"
//           className="flex-grow p-2 border rounded-md outline-none"
//         />
//         <button onClick={clearSearch} className="ml-2 text-gray-500">
//           Clear
//         </button>
//       </div>

//       {/* Grid Layout */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5 w-full">
//         {filteredLocations.map((location, index) => (
//           <div
//             key={index}
//             onClick={() => handleLocationClick(location.name)} // Dispatch action on click
//             className="w-full h-32 bg-[#FF9630] rounded-md shadow-md flex items-center justify-center text-gray-700 font-semibold cursor-pointer relative overflow-hidden"
//           >
//             <img
//               src={location.image}
//               alt={location.name}
//               className="absolute w-full h-full object-cover opacity-80"
//             />
//             <span className="relative z-10 text-white">{location.name}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ChooseLocation;


import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setLocation } from "../../Redux/Slice/locationSlice"; // Import the action
import { useNavigate } from "react-router-dom"; // Import useNavigate

import belagavi from "../assets/dhwd.jpg";
import hubli from "../assets/bgm.jpg";
import udupi from "../assets/dhwd.jpg";
import dharwad from "../assets/bgm.jpg";
import moodabidri from "../assets/dhwd.jpg";
import byndoor from "../assets/bgm.jpg";
import kundapura from "../assets/dhwd.jpg";
import kasaragod from "../assets/bgm.jpg";
import mangalore from "../assets/dhwd.jpg";
import haveri from "../assets/bgm.jpg";
import shivmogga from "../assets/dhwd.jpg";
import vijaypur from "../assets/bgm.jpg";

const ChooseLocation = () => {
  const dispatch = useDispatch(); // Redux dispatch hook
  const navigate = useNavigate(); // Initialize navigate hook

  const locations = [
    { name: "Belagavi", image: belagavi },
    { name: "Hubli", image: hubli },
    { name: "Udupi", image: udupi },
    { name: "Dharwad", image: dharwad },
    { name: "Moodabidri", image: moodabidri },
    { name: "Byndoor", image: byndoor },
    { name: "Kundapura", image: kundapura },
    { name: "Kasaragod", image: kasaragod },
    { name: "Mangalore", image: mangalore },
    { name: "Haveri", image: haveri },
    { name: "Shivmogga", image: shivmogga },
    { name: "Vijaypur", image: vijaypur },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const filteredLocations = locations.filter((location) =>
    location.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const clearSearch = () => {
    setSearchTerm("");
  };

  const handleLocationClick = (locationName) => {
    setSearchTerm(locationName); // Set the selected location to the input field
    dispatch(setLocation(locationName)); // Dispatch to Redux store
    navigate("/"); // Redirect to home page
  };

  return (
    <div className="w-full h-auto p-4 flex flex-col items-center gap-2.5 bg-gray-100 relative top-2 left-1">
      {/* Search Bar */}
      <div className="flex items-center w-full bg-white rounded-md shadow-md p-2 mb-2">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search city"
          className="flex-grow p-2 border rounded-md outline-none"
        />
        <button onClick={clearSearch} className="ml-2 text-gray-500">
          Clear
        </button>
      </div>

      {/* Grid Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5 w-full">
        {filteredLocations.map((location, index) => (
          <div
            key={index}
            onClick={() => handleLocationClick(location.name)} // Dispatch action on click
            className="w-full h-32 bg-[#FF9630] rounded-md shadow-md flex items-center justify-center text-gray-700 font-semibold cursor-pointer relative overflow-hidden"
          >
            <img
              src={location.image}
              alt={location.name}
              className="absolute w-full h-full object-cover opacity-80"
            />
            <span className="relative z-10 text-white">{location.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseLocation;
